import { TableCell as MUITableCell } from "@mui/material";
import { TableColumn, TableRow } from "./Table.types";

export interface TableCellProps {
  row: TableRow;
  column: TableColumn;
  condensed?: boolean;
}

export const TableCell = ({ row, column, condensed }: TableCellProps) => {
  const { id, Cell } = column;

  return (
    <MUITableCell key={"table-cell-" + id} sx={condensed ? { padding: 0 } : {}}>
      {Cell ? Cell(row) : row[id] ?? ""}
      <br />
    </MUITableCell>
  );
};
